// extracted by mini-css-extract-plugin
export default {"topmrgin":"upcoming_topmrgin__WKHDA","hmdis":"upcoming_hmdis__YPWzz"};